<template>
  <div v-if="isTestEnvironment" class="env-badge-wrapper d-print-none" :class="{ 'env-badge-wrapper--inline': inline }" title="Você está no ambiente de teste">
    <div class="env-badge">
      <span class="env-badge__icon">⚠</span>
      <span class="env-badge__text">AMBIENTE DE TESTE</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'EnvironmentBadge',
  props: {
    inline: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    isTestEnvironment() {
      return process.env.VUE_APP_AMBIENTE !== 'production';
    }
  }
};
</script>

<style scoped>
.env-badge-wrapper {
  position: fixed;
  bottom: 20px;
  right: 20px;
  z-index: 99999;
  display: flex;
  align-items: center;
  justify-content: center;
}

.env-badge-wrapper--inline {
  position: static;
  bottom: auto;
  right: auto;
  z-index: auto;
}

.env-badge {
  display: flex;
  align-items: center;
  gap: 6px;
  background: linear-gradient(135deg, #FF6B00, #FF3D00);
  color: #fff;
  font-weight: 700;
  font-size: 11px;
  letter-spacing: 1.2px;
  text-transform: uppercase;
  padding: 8px 14px;
  border-radius: 24px;
  box-shadow:
    0 4px 15px rgba(255, 61, 0, 0.45),
    0 0 0 2px rgba(255, 107, 0, 0.3);
  cursor: default;
  position: relative;
  z-index: 2;
  user-select: none;
}

.env-badge__icon {
  font-size: 13px;
  animation: env-icon-shake 2.5s ease-in-out infinite;
  display: inline-block;
}

.env-badge__text {
  font-family: 'Roboto', sans-serif;
}

@keyframes env-icon-shake {
  0%, 80%, 100% { transform: rotate(0deg); }
  85%           { transform: rotate(-12deg); }
  90%           { transform: rotate(12deg); }
  95%           { transform: rotate(-8deg); }
}
</style>
